import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propStr } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import LoginButton from '../Login/LoginButton';
import RegistrationLink from '../Registration/RegistrationLink';
import ModalHoc from './ModalHoc';
/**
 * 既存のLoginRequiredModalをhooks化、将来的にはこちらに入れ替える
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const LoginRequiredHooksModal = (props) => {
    const { hideModal, modalState } = props;
    return (_jsxs("div", Object.assign({ className: `fade_modal alert_modal ${modalState}` }, { children: [_jsx("div", { className: 'bg', onClick: hideModal, role: 'presentation' }), _jsxs("div", Object.assign({ className: 'modal_body' }, { children: [_jsxs("div", Object.assign({ className: 'is-nowrap' }, { children: ["\u3054\u767B\u9332\u3044\u305F\u3060\u304F\u3068\u3001", _jsx("wbr", {}), "\u8A73\u7D30\u3092\u3054\u89A7\u3044\u305F\u3060\u3051\u307E\u3059"] })), _jsx("div", Object.assign({ className: 'mt2 mb2' }, { children: _jsx(RegistrationLink, { className: 'btn btn-primary wide', text: '会員登録をする' }) })), _jsxs("div", Object.assign({ className: 'is-nowrap' }, { children: ["\u3059\u3067\u306B\u4F1A\u54E1\u306E\u65B9\u306F", _jsx(LoginButton, { className: 'link-text' }), "\u3057\u3066\u304F\u3060\u3055\u3044"] }))] }))] })));
};
LoginRequiredHooksModal.propTypes = {
    hideModal: propFunc().isRequired,
    modalState: propStr().isRequired,
};
const enhance = compose(ModalHoc);
export default enhance(LoginRequiredHooksModal);
